import Reveal from '@stimulus-components/reveal'

// https://www.stimulus-components.com/docs/stimulus-reveal-controller/
export default Reveal
